import 'lib-flexible'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import http from './http'
import api from './http/api'
import config from './config/index'
import reg from './utils/reg'
import utils from './utils/utils'
import wx from './utils/wx'
import status from './utils/status'
import moment from 'moment'

import Vant from './plugins/vant'

import components from './components/'

import './theme/main.less'

Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$api = api
Vue.prototype.$config = config
Vue.prototype.$reg = reg
Vue.prototype.$utils = utils
Vue.prototype.$status = status
Vue.prototype.$moment = moment
Vue.prototype.$wx = wx

Vue.filter('priceFilter', val => {
	const numberVal = Number(val)
	if (Number.isNaN(numberVal)) return '0.00'
	return numberVal.toFixed(2)
})

Vant(Vue)
components(Vue)
Vue.use(VueClipboard)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
